export default "__VITE_ASSET__DRfM10QQ__"